console.log('ACTIVIS - App.js loadé');

import './_header';
import './_delegate-link';
(function() {
    var $last_child = document.querySelector('.wp-block-post-content > :last-child');

    while ($last_child && $last_child.tagName === 'SCRIPT') {
        $last_child = $last_child.previousSibling;
    }
    $last_child.classList.add('last-child');
})();

/* retirer les id vide pour ne pas avoir d erreur d'accessibilité */
setTimeout(function () {
    const $refs = document.querySelectorAll("*[id='']");

    if ($refs) {

        $refs.forEach(function ($ref) {
            $ref.removeAttribute('id');
        });
    }
}, 2000);

console.log('ACTIVIS - App.js loadé');

document.addEventListener('DOMContentLoaded', () => {
    const actPageTreeMenuItem = document.querySelectorAll('.act-page-tree-menu__item');
    console.log(actPageTreeMenuItem);

    if (actPageTreeMenuItem) {
        actPageTreeMenuItem.addEventListener('mouseover', (e) => {
            console.log(e.target);
            e.target.classList.add('act-page-tree-menu__item--panel-opened');
            e.target.classList.remove('act-page-tree-menu__item--panel-closed');
        })
    }
});
